import type { ProLayoutProps } from '@ant-design/pro-components';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#0f37b2',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  pwa: true,
  logo: '/logo-luole.png',
  token: {
    header: {
      heightLayoutHeader: 52,
      colorBgHeader: '#0b2f96',
      colorBgMenuElevated: '#0b2f96',
      colorHeaderTitle: '#fff',
      colorTextMenu: 'rgba(255, 255, 255, 0.88)',
      colorTextMenuSecondary: 'rgba(255, 255, 255, 0.72)',
      colorTextMenuSelected: '#fff',
      colorBgMenuItemSelected: 'rgba(255, 255, 255, 0.18)',
      colorTextMenuActive: '#fff',
      colorBgMenuItemHover: 'rgba(255, 255, 255, 0.12)',
      colorTextRightActionsItem: 'rgba(255, 255, 255, 0.88)',
    },
  },
  splitMenus: true,
  siderMenuType: 'sub',
  // 主内容区不留 padding
  contentStyle: {
    padding: 0,
  },
  title: getBrandAppName(),
};
export default Settings;
